import React, { useEffect, useState } from "react";
import DashboardHeader from "./DashboardHeader";
import Footer from "./Footer"
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";
import { loadUnread } from "../utils/unread";

function DashboardLayout() {
    // The side menu can be folded away on a computer. The choice is remembered on this device.
    const [menuCollapsed, setMenuCollapsed] = useState(() => {
        try {
            return localStorage.getItem("menu_collapsed") === "1";
        } catch (error) {
            return false;
        }
    });

    const toggleMenu = () => {
        setMenuCollapsed((previous) => {
            try {
                localStorage.setItem("menu_collapsed", previous ? "0" : "1");
            } catch (error) {
                // Private browsing: the choice lasts until the page is closed.
            }
            return !previous;
        });
    };

    // Keep the unread notification count fresh while someone is signed in:
    // once a minute, and whenever they come back to the window.
    useEffect(() => {
        loadUnread();
        const timer = setInterval(loadUnread, 60000);
        window.addEventListener("focus", loadUnread);

        return () => {
            clearInterval(timer);
            window.removeEventListener("focus", loadUnread);
        };
    }, []);

    return (
        <div className="cf-dash">
            <div className="cf-dash-body">
                <div className={`cf-side-col ${menuCollapsed ? "is-collapsed" : ""}`}>
                    <Sidebar collapsed={menuCollapsed} onToggleCollapse={toggleMenu} />
                </div>
                <div className="cf-main-col">
                    <DashboardHeader />
                    <main className="main dash-main">
                        <Outlet />
                    </main>
                </div>
            </div>
            <Footer slim />
        </div>
    );
}

export default DashboardLayout;
